import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LineCap } from '@progress/kendo-drawing';


@Component({
    selector: 'app-arc-gauge',
    templateUrl: './arc-gauge.html',
    styleUrls: ['./arc-gauge.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class ArcgaugeComponent {
  public startAngle: number = -55;
  public endAngle: number = 235;
  public rangeSize: number = 10;
  public rangePlaceholderColor = '#E5E5E4';
  public rangeLineCap: LineCap = 'square';
  public colors: any[] = [
    {
      to: 50,
      color: '#91D0B3'
    },
    {
      from: 51,
      to: 75,
      color: '#91D0B3'
    },
    {
      from: 76,
      color: '#91D0B3'
    }
  ];

}
